import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import Swal from "sweetalert2";
import router from "@/router";
//import MenuDataService from "./menus/menus.module";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUserPassword";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
export const CLEAR_REGISTER_ERROR = "clearRegisterError";
//export const SET_PERMISSIONS = "setPermissions";

const state = {
    errors: {},
    user: {},
    permissions:{},
    isAuthenticated: !!JwtService.getToken()
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("/auth/login", credentials)
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if(response.data.error === "Unauthorized") {
                        Swal.fire({
                            title: "",
                            text: "Kullanıcı adı veya şifre hatalı, lütfen tekrar deneyiniz!",
                            icon: "error",
                            confirmButtonClass: "btn btn-secondary",
                            heightAuto: false
                        });
                    }

                    if(response.data.error === "Yetkisiz") {
                        Swal.fire({
                            title: "",
                            text: "Kullanıcı statüsü login yapmaya yetkili değil!",
                            icon: "error",
                            confirmButtonClass: "btn btn-secondary",
                            heightAuto: false
                        });
                    }
                    context.commit(SET_ERROR, response.data.error);
                });
        });
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
    },
    [REGISTER](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("/auth/register", credentials)
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    context.commit(CLEAR_REGISTER_ERROR);
                    resolve(data);
                })
                .catch(({ response }) => {
                    if (response.data.error === "member_data_match_error") {
                        Swal.fire({
                            title: "",
                            text: "Girdiğiniz üye bilgileri ile sistemimizdeki üye bilgileri eşleşmedi. Lütfen ilgili dernek yöneticisi ile iletişime geçin! 0533 838 87 87",
                            icon: "error",
                            confirmButtonClass: "btn btn-secondary",
                            heightAuto: false,
                        });
                    } else if (response.data.warning === "existing_membership_found") {
                        Swal.fire({
                            title: "Mevcut Üyeliğiniz Bulundu",
                            text: `${response.data.message} Üye Numaranız: ${response.data.member_no}.`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Yeni Üyelik Yarat",
                            cancelButtonText: "İptal",
                            heightAuto: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                context.commit(CLEAR_REGISTER_ERROR);
                                credentials.force_new_membership = true; // Force new membership
                                setTimeout(() => {
                                    ApiService.post("/auth/register", credentials)
                                        .then(() => {
                                            context.commit(CLEAR_REGISTER_ERROR);
                                            Swal.fire({
                                                title: "",
                                                text: "Kaydınız başarıyla yapıldı. Giriş yapabilirsiniz.",
                                                icon: "success",
                                                confirmButtonClass: "btn btn-secondary",
                                                heightAuto: false,
                                            });
                                            router.push({ name: "my-membership" }); // Navigate after successful retry
                                        })
                                        .catch((error) => {
                                            context.commit(SET_ERROR, error.response?.data?.errors || {});
                                        });
                                }, 500);
                            }
                        });
                    } else if (response.data.error === "member_status_error") {
                        Swal.fire({
                            title: "Üyelik İşlemi Yapılamaz",
                            text: "Üyenin durumu İHRAÇ veya İSTİFA olarak kaydedilmiş. Üyelik işlemi yapılamaz. Lütfen ilgili dernek yöneticisi ile iletişime geçin! 0533 838 87 87",
                            icon: "error",
                            confirmButtonClass: "btn btn-secondary",
                            heightAuto: false,
                        });
                    } else {
                        // For other errors, commit them to the store
                        context.commit(SET_ERROR, response.data.errors);
                    }
                    // Reject the promise for error cases
                    reject(response);
                });
        });
    },
    
    
    [VERIFY_AUTH](context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            //console.log(JwtService.getToken());

            ApiService.get("/auth/user-profile")
            .catch(() => {
                context.commit(PURGE_AUTH);
            })
           
        } else {
            //console.log('session timed out');
            //router.push({ name: "users" })
            context.commit(PURGE_AUTH);
        }
    },
    [UPDATE_PASSWORD](context, payload) {
        const password = payload;
        return ApiService.put("password", password).then(({ data }) => {
            context.commit(SET_PASSWORD, data);
            return data;
        });
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
        state.errors = {};
        JwtService.saveToken(state.user.access_token);
    },
    [SET_PASSWORD](state, password) {
        state.user.password = password;
    },
    
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
        JwtService.destroyToken();
        
    },

    [CLEAR_REGISTER_ERROR](state) {
        state.errors = {};
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
